var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNaira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3336 5C18.3336 4.44772 17.8858 4 17.3336 4C16.7813 4 16.3336 4.44772 16.3336 5V9.28571H11.3925L8.41496 4.81934C7.59172 3.58448 5.66688 4.16728 5.66688 5.65139V9.28571H4C3.44772 9.28571 3 9.73343 3 10.2857C3 10.838 3.44772 11.2857 4 11.2857H5.66688V12.7143H4C3.44772 12.7143 3 13.162 3 13.7143C3 14.2666 3.44772 14.7143 4 14.7143H5.66688V19C5.66688 19.5523 6.1146 20 6.66688 20C7.21917 20 7.66688 19.5523 7.66688 19V14.7143H12.6079L15.5855 19.1807C16.4087 20.4155 18.3336 19.8327 18.3336 18.3486V14.7143H20C20.5523 14.7143 21 14.2666 21 13.7143C21 13.162 20.5523 12.7143 20 12.7143H18.3336V11.2857H20C20.5523 11.2857 21 10.838 21 10.2857C21 9.73343 20.5523 9.28571 20 9.28571H18.3336V5ZM13.6783 12.7143L12.7259 11.2857H16.3336V12.7143H13.6783ZM16.3336 16.6972L15.0116 14.7143H16.3336V16.6972ZM10.3222 11.2857L11.2746 12.7143H7.66688V11.2857H10.3222ZM7.66688 7.30278L8.98884 9.28571H7.66688V7.30278Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNaira);
export default __webpack_public_path__ + "static/media/ic_naira.87b210848ef5c13c0063f1365cf5d6bb.svg";
export { ForwardRef as ReactComponent };